// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.csi-middleware-customView-CustomViewFavoriteButton-module-button {
	margin-top: -3px;
	margin-bottom: -3px;
	border: 0;
}`, "",{"version":3,"sources":["webpack://./src/csi/middleware/customView/CustomViewFavoriteButton.module.css"],"names":[],"mappings":"AAAA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,SAAS;AACV","sourcesContent":[".button {\n\tmargin-top: -3px;\n\tmargin-bottom: -3px;\n\tborder: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `csi-middleware-customView-CustomViewFavoriteButton-module-button`
};
module.exports = ___CSS_LOADER_EXPORT___;
